// extracted by mini-css-extract-plugin
export default {"page":"bT96V8w2s34H7x9YsaO4","noOrderFound":"Nup3TutQ2JCUDJnRlrtQ","form":"UzdZxOyq4j5eY2Sw0Rix","securityNote":"utpiJSh6L_AEWJCUxrNv","orderInfo":"n3luNOY4mirc2Iq3O6kI"};